import './index.scss';
import ChartSummarySection from '../commons/chart-summary/index.js';
import React, { Component } from "react";
import Chart from "react-apexcharts";
import moment from 'moment';
import { __ } from '@wordpress/i18n';

function wisdmLDRConvertTime(seconds) {                     
  var seconds = parseInt(seconds, 10)                      
  var hours   = Math.floor(seconds / 3600)                 
  var minutes = Math.floor((seconds - (hours * 3600)) / 60)
  var seconds = seconds - (hours * 3600) - (minutes * 60)  
  if ( !!hours ) {                                         
    if ( !!minutes ) {                                     
      return `${hours}h ${minutes}m ${seconds}s`           
    } else {                                               
      return `${hours}h ${seconds}s`                       
    }                                                      
  }                                                        
  if ( !!minutes ) {                                       
    return `${minutes}m ${seconds}s`                       
  }                                                        
  return `${seconds}s`                                     
}

class QuizCompletionTimePerCourse extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      error: null,   
      graph_type:'bar',
      series:[],
      options:[],
      graph_summary:[],
      learner_filter_applied:false,
      course_filter_applied:false,
      start_date:moment(new Date(wisdm_ld_reports_common_script_data.start_date)).unix(),
      end_date:moment(new Date(wisdm_ld_reports_common_script_data.end_date)).unix(),
      reportTypeInUse: wisdm_learndash_reports_front_end_script_quiz_completion_time_per_course.report_type,
      chart_title:__('Quiz Completion Time', 'learndash-reports-by-wisdmlabs'),
      help_text:__('This Report displays the total time spent by the Learners on Quizzes in each Course.','learndash-reports-by-wisdmlabs'),
    };

    this.durationUpdated        = this.durationUpdated.bind(this);
    this.applyFilters           = this.applyFilters.bind(this);
    this.handleReportTypeChange = this.handleReportTypeChange.bind(this);
  }

  isValidGraphData() {
    if (undefined==this.state.options || 0==this.state.options.length) {
      return false;
    } 
    if (undefined==this.state.series || undefined==this.state.series[0]) {
      return false;
    }
    if (undefined==this.state.series[0] || 0==this.state.series[0].length) {
      return false;
    }
    return true;
  }


  componentDidMount() {   
    this.updateChart('/rp/v1/quiz-completion-time-per-course/?start_date=' + this.state.start_date + "&&end_date=" + this.state.end_date);
    document.addEventListener('duration_updated', this.durationUpdated); 
    document.addEventListener('wisdm-ld-reports-filters-applied', this.applyFilters);
    document.addEventListener('wisdm-ld-reports-report-type-selected', this.handleReportTypeChange);
  }

  componentDidUpdate() {
    jQuery('.wisdm-learndash-reports-quiz-completion-time-per-course .mixed-chart').prepend(jQuery('.wisdm-learndash-reports-quiz-completion-time-per-course .apexcharts-toolbar'));
    jQuery( ".wisdm-learndash-reports-quiz-completion-time-per-course .chart-title .dashicons" ).hover(

      function() {
        var $div = jQuery('<div/>').addClass('wdm-tooltip').css({
            position: 'absolute',
            zIndex: 999,
            display: 'none'
        }).appendTo(jQuery(this));
        $div.text(jQuery(this).attr('data-title'));
        $div.show();
      }, function() {
        jQuery( this ).find( ".wdm-tooltip" ).remove();
      }
    );
  }

  handleReportTypeChange(event) {
    this.setState({reportTypeInUse:event.detail.active_reports_tab});
  }

  updateChart(requestUrl) {
    this.setState({isLoaded:false, error:null});
    wp.apiFetch({
      path: requestUrl //Replace with the correct API
   }).then(response => {
        this.plotChartTypeBy(response); 
      }).catch((error) => {
        this.setState({
          error:error,
              graph_summary:[],
          isLoaded: true,
          series:[],
        })
      });
  }

  plotChartTypeBy(response) {
    if (undefined!=response.courseWiseTime) {
      const time = Object.values( response.courseWiseTime ).map( obj => parseInt( obj.time ) );
      const courses = Object.values( response.courseWiseTime ).map( obj => obj.course );
      let labelX = this.state.learner_filter_applied?__('Quizzes', 'learndash-reports-by-wisdmlabs'):__('Courses', 'learndash-reports-by-wisdmlabs');
      this.plotBarChart(courses, time, labelX, __('Time spent on Quizzes', 'learndash-reports-by-wisdmlabs'));

      let summaryLeftLabel =  __('AVERAGE QUIZ COMPLETION TIME PER COURSE.', 'learndash-reports-by-wisdmlabs');
      summaryLeftLabel = this.state.learner_filter_applied?__('AVERAGE QUIZ COMPLETION TIME', 'learndash-reports-by-wisdmlabs'):summaryLeftLabel;
      this.setState(
        {
        isLoaded: true,
        graph_summary: {
          left: [{
                title : summaryLeftLabel,
                value: wisdmLDRConvertTime(response.averageCourseTime),
              },],
              
          right:[ 
            {
              title: __('Total Time Spent: ', 'learndash-reports-by-wisdmlabs'),
              value:wisdmLDRConvertTime(response.courseTotalTime),
            }],
        },
      });

    } else if(undefined!=response.learnerWiseTime) {
      let user_names = Object.values( response.learnerWiseTime ).map( obj => obj.name );
      let time  = Object.values( response.learnerWiseTime ).map( obj => obj.time );
      this.plotBarChart(user_names, time, __('Learners', 'learndash-reports-by-wisdmlabs'), __('Average Quiz Completion Time.', 'learndash-reports-by-wisdmlabs'));          
      this.setState(
        {
        isLoaded: true,
        graph_summary: {
          left: [{
                title : __('AVERAGE QUIZ COMPLETION TIME PER LEARNER.', 'learndash-reports-by-wisdmlabs'),
                value: wisdmLDRConvertTime(response.averageQuizTime),
              },],
              
          right:[ 
            {
              title: __('Total Time Spent: ', 'learndash-reports-by-wisdmlabs'),
              value:wisdmLDRConvertTime(response.quizTotalTime),
            }],
        },
      });
    }
  }

  plotBarChart(dataX, dataY, nameX, nameY) {
    let chart_options = {
      chart: {
        id: "basic-bar",
        width: dataX.length*75 < 645 ? '100%' : dataX.length*75,
        height: 400,
        zoom:{
          enabled:false,
        },
        toolbar:{
          show:true,
          export: {
            csv: {
              filename: __( 'Completion Time.csv', 'learndash-reports-by-wisdmlabs' ),
              columnDelimiter: ',',
              headerCategory: nameX,
              headerValue: nameY,
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            }
          },
        }
      },
      colors: ["#008AD8"],
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return wisdmLDRConvertTime( val );
        },
        offsetY: -25,
        style: {
          fontSize: '12px',
          colors: ["#008AD8"]
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 5,
          columnWidth: '30%',
          dataLabels:{
            enabled: true,
            position:'top',
          }
        }
      },
      xaxis: {
        title: {
          text: nameX,
        },
        categories: dataX,
        labels:{
          hideOverlappingLabels: false,
          trim: true,
        },
        tickPlacement: 'on',
        min:1,
      },
      yaxis: {
        max: Math.max.apply(Math, dataY) + Math.max.apply(Math, dataY)/10,
        axisBorder: {
          show: true
        },
        title: {
          text: nameY,
        },
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function(value){return wisdmLDRConvertTime(value)},
          title:{
            formatter:function(title) {
              return __('Time Spent: ', 'learndash-reports-by-wisdmlabs');
            }
          },
        },
      }
    };
    this.setState({graph_type:'bar', series:[{name:nameY, data:dataY}], options:chart_options});
  }

  applyFilters(event) {
    let start_date = event.detail.start_date;
    let end_date   = event.detail.end_date;
    let category   = event.detail.selected_categories;
    let course     = event.detail.selected_courses;
    let lesson     = event.detail.selected_lessons;
    let topic      = event.detail.selected_topics;
    let learner    = event.detail.selected_learners;
    
    
    this.setState({learner_filter_applied:null!=learner?true:false, error: null});
    this.setState({course_filter_applied:null!=course?true:false, error: null,});
    
 
    let request_url = '/rp/v1/quiz-completion-time-per-course/?start_date=' + start_date + '&end_date=' + end_date + '&category=' + category + '&course=' + course + '&lesson=' + lesson + '&topic=' + topic + '&learner=' + learner;
 
    this.updateChart(request_url)
   
   }

  durationUpdated(event) {
    this.setState({isLoaded: false, start_date:event.detail.startDate, end_date:event.detail.endDate});
    let requestUrl = '/rp/v1/quiz-completion-time-per-course/';
    if ('duration_updated'==event.type) {
      requestUrl = '/rp/v1/quiz-completion-time-per-course/?start_date=' + event.detail.startDate + '&&end_date=' + event.detail.endDate;
    } 
    this.updateChart(requestUrl);
  }

  render() {
    let body = <div></div>;
    let data_validation = '';
    if (!this.isValidGraphData()) {
      data_validation = 'invalid-or-empty-data';
    }
    if(''!=this.state.reportTypeInUse && 'default-ld-reports'!=this.state.reportTypeInUse) {
      body = '';
    } else if (!this.state.isLoaded) {
      // yet loading
      body =  <div class="wisdm-learndash-reports-chart-block wisdm-ld-loading">
                <div>{__('Loading...', 'learndash-reports-by-wisdmlabs')}</div>
              </div>
  } else {
    let graph = '';
    if (!this.state.error) {
      graph = <div className="app">
                <div className="row">
                  <div className="mixed-chart">
                    <Chart
                      options={this.state.options}
                      series={this.state.series}
                      type={this.state.graph_type}
                      width={this.state.options.chart.width}
                      height={this.state.options.chart.height}
                    />
                  </div>
                </div>
              </div>;
    }
    body = 
    <div class={"wisdm-learndash-reports-chart-block " + data_validation}>  
      <div class="wisdm-learndash-reports-quiz-completion-time-per-course graph-card-container">
        <div class="chart-header quiz-completion-time-per-course-chart-header">
          <div class="chart-title">
            <span>{this.state.chart_title}</span>
            <span class="dashicons dashicons-info-outline widm-ld-reports-info" data-title={this.state.help_text}></span>
          </div>
          <ChartSummarySection wrapper_class='chart-summary-quiz-completion-time-per-course' graph_summary={this.state.graph_summary} error={this.state.error}/>
        </div>
        <div>
          {graph}
        </div>
      </div>
    </div>;
  }    
    return (body);
  }
}


document.addEventListener("DOMContentLoaded", function(event) {
  let elem = document.getElementsByClassName('wisdm-learndash-reports-quiz-completion-time-per-course front');
  if (elem.length>0) {
    ReactDOM.render(React.createElement(QuizCompletionTimePerCourse), elem[0]); 
  }
});

